import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AuthGuard } from './auth/guard.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './/app-routing.module';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { EntradaCaminhoesComponent } from './pages/entrada-caminhoes/entrada-caminhoes.component';
import { NavbarComponent } from './pages/navbar/navbar.component';
import { HttpClientModule } from '@angular/common/http';
import { PlataformaComponent } from './pages/plataforma/plataforma.component';
import { FormsModule } from '@angular/forms';
import { ServicesService } from './services.service';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    EntradaCaminhoesComponent,
    NavbarComponent,
    PlataformaComponent
  ],
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('/ngsw-worker.js', {
      enabled: environment.production
    }),
    AppRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [AuthGuard, ServicesService, AppComponent],
  bootstrap: [AppComponent]
})
export class AppModule {}
